import { Button } from "@component/button";
import { SearchXIcon, ArrowLeftIcon } from "lucide-react";

interface Props {
    onBackToJobs?: () => void;
}

export function JobNotFound(props: Props) {
    return (
        <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div className="bg-gray-100 rounded-full p-5 mb-6">
                <SearchXIcon className="h-12 w-12 text-gray-400" />
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-2">Job Not Found</h2>
            <p className="text-gray-600 mb-6 max-w-md">
                Sorry, the job you're looking for is no longer available or has been
                removed.
            </p>

            {props.onBackToJobs && (
                <div className="flex flex-col sm:flex-row gap-3">
                    <Button
                        variant="outline"
                        className="flex items-center gap-2"
                        onClick={props.onBackToJobs}
                    >
                        <ArrowLeftIcon className="h-4 w-4" />
                        Back to Job Listings
                    </Button>
                </div>
            )}
        </div>
    );
}
